import React from 'react';
import PropTypes from 'prop-types';
import {
  Check,
  ChevronDown,
  Heading1,
  Heading2,
  Heading3,
  List,
  ListOrdered,
  Pilcrow,
  Quote,
} from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../../../ui/popover';

const STYLE_ICON_BY_ID = {
  paragraph: Pilcrow,
  h1: Heading1,
  h2: Heading2,
  h3: Heading3,
  quote: Quote,
  bullet: List,
  number: ListOrdered,
};

const preventMouseDownFocusLoss = (event) => {
  event.preventDefault();
};

export function ReportDraftStyleMenu({
  label,
  currentLabel,
  items,
  wrapperZIndex,
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="report-draft-editor__toolbar-dropdown report-draft-editor__toolbar-dropdown--style"
          aria-label={label}
          title={label}
          onMouseDown={preventMouseDownFocusLoss}
        >
          <span className="report-draft-editor__toolbar-dropdown-label">{currentLabel || label}</span>
          <ChevronDown size={14} />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        sideOffset={2}
        wrapperZIndex={wrapperZIndex}
        className="report-draft-editor__toolbar-menu report-draft-editor__toolbar-menu--style"
      >
        <div className="report-draft-editor__toolbar-menu-section">
          {items.map((item) => {
            const RowIcon = STYLE_ICON_BY_ID[item.id] || Pilcrow;
            return (
              <button
                key={item.id}
                type="button"
                className={`report-draft-editor__toolbar-menu-item${item.isActive ? ' is-active' : ''}`}
                onMouseDown={preventMouseDownFocusLoss}
                onClick={item.onSelect}
                aria-pressed={item.isActive}
              >
                <span className="report-draft-editor__toolbar-menu-item-leading">
                  <span className="report-draft-editor__toolbar-menu-item-icon" aria-hidden="true">
                    <RowIcon size={14} />
                  </span>
                  <span className="report-draft-editor__toolbar-menu-item-copy">
                    <span className="report-draft-editor__toolbar-menu-item-label">{item.label}</span>
                    {item.shortcut ? (
                      <span className="report-draft-editor__toolbar-menu-shortcut">{item.shortcut}</span>
                    ) : null}
                  </span>
                </span>
                {item.isActive ? <Check size={14} /> : <span className="report-draft-editor__toolbar-menu-check-placeholder" />}
              </button>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
}

ReportDraftStyleMenu.propTypes = {
  label: PropTypes.string.isRequired,
  currentLabel: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    shortcut: PropTypes.string,
    isActive: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
  })).isRequired,
  wrapperZIndex: PropTypes.number,
};

ReportDraftStyleMenu.defaultProps = {
  currentLabel: '',
  wrapperZIndex: undefined,
};
